export default "__VITE_ASSET__BDY$pgSg__"